
import Card from "@/components/base/card/Card"
import Timestamp from "@/components/base/card/Timestamp"
import ProgressLinear from "@/components/base/ProgressLinear"

import sanitizeText from "@/utils/sanitize-text"
import eventService from "@/services/event.service"
export default {
    name: "EventDetailCard",
    components: { Card, Timestamp, ProgressLinear },
    props: {
        /** Event object, index or detail version (automatically fetched)*/
        event: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        detailEvent: null,
        isLoading: false,
    }),
    computed: {
        isOabatPost() {
            return this.detailEvent?.creator.profile_path == "/betriebe/oabat"
        },
        linkedText() {
            const text = this.detailEvent?.text
            if (!text) return ""
            return sanitizeText(text, true)
        },
    },
    mounted() {
        if (this.event.text) {
            this.detailEvent = this.event
            return /** Is already detailed */
        }
        this.isLoading = true
        eventService
            .getEvent(this.event.slug)
            .then((response) => {
                this.detailEvent = response
            })
            .finally(() => {
                this.isLoading = false
            })
    },
}
